import { Alert, AlertTitle, Button, Stack } from '@mui/material';
import { Link } from 'react-router-dom';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import { FOOD_DELIVERY_ROUTES } from '../helpers';

/**
 * Boş ekran yönlendirmesi (plan Faz 4.2).
 *
 * Eskiden bu ekranlar yalnız "entegrasyon yok" diyordu; kullanıcı nereye
 * gideceğini bilmiyordu. Artık her boş durum, çözümün bulunduğu sayfaya
 * TIKLANABİLİR bir bağlantı verir.
 */

interface FoodDeliveryEmptyStateProps {
  /** Ne eksik olduğunu anlatan cümle. */
  message: string;
  /** Başlık (kısa durum ifadesi). */
  title?: string;
  /** Yönlendirme hedefi; varsayılan: entegrasyon listesi. */
  to?: string;
  /** Bağlantı düğmesinin metni. */
  actionLabel?: string;
  severity?: 'info' | 'warning';
}

const FoodDeliveryEmptyState = ({
  message,
  title,
  to = FOOD_DELIVERY_ROUTES.integrations,
  actionLabel = 'Yemek Platformları’na git',
  severity = 'info'
}: FoodDeliveryEmptyStateProps) => (
  <Alert severity={severity}>
    {title && <AlertTitle>{title}</AlertTitle>}
    <Stack spacing={1} alignItems="flex-start">
      <span>{message}</span>
      <Button
        component={Link}
        to={to}
        size="small"
        variant="outlined"
        startIcon={<SettingsSuggestIcon fontSize="small" />}
      >
        {actionLabel}
      </Button>
    </Stack>
  </Alert>
);

export default FoodDeliveryEmptyState;
